<div class="flex h-screen w-screen flex-col lg:grid lg:grid-cols-[70%_30%]">
    <div
        class="flex h-[35vh] w-full items-center justify-center border-gray-200 bg-cover bg-center lg:h-auto lg:w-auto lg:border-r"
        style="background-image: url('/welcome-image.png')"
    ></div>

    <div class="relative flex flex-1 flex-col items-center gap-4 bg-white p-6 shadow-xl md:justify-center lg:h-auto">
        <img
            src="/ballance-logo.png"
            alt="Ballance"
            class="absolute right-4 bottom-4 h-auto w-[100px] opacity-80 lg:w-[160px] lg:opacity-100"
        />

        <h1 class="md:mt-4text-blue-950 text-center text-2xl lg:text-3xl">Welcome to</h1>

        <h2 class="text-md text-center font-semibold text-blue-900 md:mb-4 lg:text-xl">
            Ballance Assistant<br />
            <span class="block font-normal text-blue-400 lg:inline">Dashboard</span>
        </h2>

        <small class="w-4/5 text-center text-sm text-gray-400 lg:w-1/2">
            Please sign-in using<br />your Microsoft account.
        </small>

        <p-button label="Login" icon="pi pi-sign-in" severity="primary" [rounded]="true" (click)="login.emit()" />
    </div>
</div>
